module.exports = __webpack_public_path__ + "static/media/hodgens_fyfe_granda_riviero_lombardia_balanca.14b8de83.jpg";